/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { shape, object, string } from 'prop-types';

import { storage } from 'utils/storage';
import { createUrl } from 'utils/urlHelper';

import p from 'polyglot/polyglot';

import Button from 'components/Button/Button';

/**
 * This is the ManageButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ManageButton extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    talentId: string.isRequired,
    talents: shape({
      query: object.isRequired,
    }).isRequired,
  };

  shouldComponentUpdate() {
    return false;
  }

  onClick = e => {
    e.preventDefault();

    const {
      talentId,
      talents: { query },
    } = this.props;

    storage.write('cached_talent_query', query);

    window.location.href = `${createUrl(
      'editProfile'
    )}?as_user=MANAGE_${talentId}`;
  };

  /**
   * Render ManageButton.
   *
   * @return {Object}
   */
  render() {
    return (
      <Button onClick={this.onClick} {...this.props}>
        {p.t('profile.manage_button')}
      </Button>
    );
  }
}

export default connect(({ talents }) => ({ talents }))(ManageButton);
